import { supo, hipNew } from '../api';
import ActionTypes from '../constants/ActionTypes';
import { isJobLoaded } from '../selectors/job';
import { fetchCategory, fetchCategorySuggestions } from './category';
import { fetchLocation } from './location';
import qs from 'query-string';
import omit from 'lodash/omit';
import { replace } from 'react-router-redux';
import { getToken } from '../selectors/user';

export const fetchJob = (id: number, force?: boolean) => {
  return async (dispatch, getState) => {
    if (!force && isJobLoaded(getState(), id)) return;
    const token = getToken(getState());
    try {
      const { data: job } = await supo.get(`/jobs/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      await dispatch(fetchCategory(job.categoryId));
      await dispatch(fetchCategorySuggestions(job.categoryId));
      await dispatch(fetchLocation(job.suburbId));
      return dispatch({
        type: ActionTypes.FETCH_JOB_SUCCESS,
        payload: job
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        dispatch({
          type: ActionTypes.FETCH_JOB_NOT_FOUND,
          payload: { id },
          error
        });
        return dispatch({
          type: ActionTypes.HARD_REDIRECT_TO,
          payload: '/account/jobs'
        });
      }
      return dispatch({
        type: ActionTypes.FETCH_JOB_ERROR,
        payload: { id },
        error
      });
    }
  };
};

export const fetchJobInvitations = id => {
  return async (dispatch, getState) => {
    const token = getToken(getState());
    try {
      const { data: invitations } = await supo.get(`/jobs/${id}/invitations`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      return dispatch({
        type: ActionTypes.FETCH_JOB_INVITATIONS_SUCCESS,
        payload: invitations
      });
    } catch (error) {
      return dispatch({
        type: ActionTypes.FETCH_JOB_INVITATIONS_ERROR,
        payload: { id },
        error
      });
    }
  };
};

export const fetchJobConnections = id => {
  return async (dispatch, getState) => {
    const token = getToken(getState());
    try {
      const { data: connections } = await supo.get(`/jobs/${id}/connections`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      return dispatch({
        type: ActionTypes.FETCH_JOB_CONNECTIONS_SUCCESS,
        payload: connections
      });
    } catch (error) {
      return dispatch({
        type: ActionTypes.FETCH_JOB_CONNECTIONS_ERROR,
        payload: { id },
        error
      });
    }
  };
};

export const fetchJobStatus = id => {
  return async (dispatch, getState) => {
    const token = getToken(getState());
    try {
      const { data: status } = await supo.get(`/jobs/${id}/status`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      return dispatch({
        type: ActionTypes.FETCH_JOB_STATUS_SUCCESS,
        payload: status
      });
    } catch (error) {
      return dispatch({
        type: ActionTypes.FETCH_JOB_STATUS_ERROR,
        payload: { id },
        error
      });
    }
  };
};

export function markCheckpoint(id, checkpoint, time) {
  return {
    type: ActionTypes.MARK_CHECKPOINT,
    payload: {
      id: `${id}-${checkpoint}`,
      marked: true,
      time: time || +new Date()
    }
  };
}
``;

export function clearCheckpoint(id, checkpoint) {
  return {
    type: ActionTypes.UNMARK_CHECKPOINT,
    payload: { id: `${id}-${checkpoint}` }
  };
}

export function checkIfFirstView(id) {
  return (dispatch, getState) => {
    const state = getState();
    const { location } = state.router;
    if (!location) return;
    const query = qs.parse(location.search);
    if (query.fty) {
      dispatch({ type: ActionTypes.SET_IS_FIRST_VIEW, payload: { id } });
      if (query.hiprojects === '0') {
        dispatch({ type: ActionTypes.MODAL_HIPROJECTS_STATUS, payload: false });
      }
      setTimeout(() => {
        const state = getState();
        const { location } = state.router;
        dispatch(
          replace({
            pathname: location.pathname,
            search: qs.stringify(omit(query, ['fty', 'job_saved', 'job_id', `hiprojects`]))
          })
        );
      }, 10000);
      setTimeout(() => {
        const state = getState();
        const { location } = state.router;
        const query = qs.parse(location.search);
        dispatch(
          replace({
            pathname: location.pathname,
            search: qs.stringify(omit(query, 'u'))
          })
        );
      }, 60000);
    }
  };
}

export function connectWaitlist(jobId, assignmentId) {
  return async dispatch => {
    dispatch({
      type: ActionTypes.CONNECTION_ADD_WAITLIST_REQUEST,
      payload: { id: assignmentId }
    });
    // TODO success/error states for cleanliness
    await hipNew.post('/api/success/connect', {
      assignment_id: assignmentId
    });
    return dispatch(fetchJobConnections(jobId));
  };
}
